import { Card, Colors, Elevation } from "@blueprintjs/core";
import { css } from "glamor";
import * as _ from "lodash";
import * as React from "react";
import { Link } from "react-router-dom";
import Loading from "src/Loading";
import { getActiveFights } from "../api";
import { FightOverview } from "../Interfaces";

const styles = {
	container: css({
		display: "flex",
		justifyContent: "center",
		width: "100%",
		flexWrap: "wrap",
	}),
	card: (dark: boolean) =>
		css({
			width: "260px",
			margin: "20px",
			fontSize: "30px",
			display: "inline-flex",
			justifyContent: "space-evenly",
		}),
	text: (dark: boolean) =>
		css({
			color: dark ? "" : Colors.DARK_GRAY2 + " !important",
			":hover": {
				color: dark ? "" : Colors.DARK_GRAY2 + " !important",
				textDecoration: "underline",
				textDecorationColor: dark ? "" : Colors.DARK_GRAY2 + " ! important",
			},
		}),
};

interface State {
	fights: FightOverview[];
}
interface Props {
	dark: boolean;
}

export default class FightSelector extends React.Component<Props, State> {
	public state = { fights: [] as FightOverview[] };
	public async componentWillMount() {
		const fights = await getActiveFights();
		this.setState({ fights });
	}
	public render() {
		return (
			<div>
				<div {...styles.container}>
					{this.state.fights.length === 0 ? (
						<Loading />
					) : (
						_.sortBy(this.state.fights, ["name"]).map((fight) => (
							<div key={fight.id}>
								<Link to={"/fights/" + fight.id} {...styles.text(this.props.dark)}>
									<Card
										{...styles.card(this.props.dark)}
										interactive={true}
										elevation={Elevation.TWO}
									>
										<span {...styles.text(this.props.dark)}>{fight.name}</span>
									</Card>
								</Link>
							</div>
						))
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/FightSelector.tsx